import React, { ReactNode } from 'react';

import { FilterValue, FilterValueDefault } from '@lib/azgaz-ui/connect';

export default (
  officesName: {
    [K: string]: string;
  },
  filters?: FilterValue[]
) => {
  let result: { title: ReactNode; value: string }[] = [];

  if (!filters) {
    return result;
  }

  const offices = filters.find(
    ({ name }) => name === 'office_ids'
  ) as FilterValueDefault;

  if (offices && offices.values) {
    result = offices.values.map(office => ({
      title: (
        <>
          <span className="select-dropdown-menu-item-value">
            {officesName[office.id] || ''}
          </span>
          <span className="select-dropdown-menu-item-count">
            ({office.count})
          </span>
        </>
      ),
      value: office.id,
    }));
  }

  return result;
};
